module.exports = __webpack_public_path__ + "static/img/mian-b.a58eddb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mian-b.png
// module id = 16RC
// module chunks = 1